import { service } from '@ember/service';
import Component from '@glimmer/component';

import type ScrollLockManager from 'volta/services/scroll-lock-manager';
import type Owner from '@ember/owner';

interface BvScrollLockSignature {
  Args: {
    selector?: string;
  };
}

export default class BvScrollLockComponent extends Component<BvScrollLockSignature> {
  @service scrollLockManager!: ScrollLockManager;

  constructor(owner: Owner, args: BvScrollLockSignature['Args']) {
    super(owner, args);
    this.scrollLockManager.setSelector(this.args.selector);
    this.scrollLockManager.registerScrollLock();
  }

  willDestroy() {
    super.willDestroy();
    this.scrollLockManager.unregisterScrollLock();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvScrollLock: typeof BvScrollLockComponent;
    'bv-scroll-lock': typeof BvScrollLockComponent;
  }
}
